import React from "react";
import DetailIconWrapper from "@/components/controls/Task/DetailIconWrapper";
import IconContainer from "@/components/ui/icon-container";
import { BellRing } from "@dreamhub/designsystem/icons";
import { Reminder } from "@/entities/tasks/types";
import Text from "@/components/ui/text";
import { useTranslation } from "react-i18next";
import { formatReminder } from "@/entities/tasks/helpers";
import { map } from "lodash";

interface Props {
  reminders: {
    items: Reminder[];
  };
  className?: string;
}

const RemindersIndicator: React.FC<Props> = ({ reminders, className }) => {
  const { t } = useTranslation();
  return (
    <DetailIconWrapper
      tooltip={
        <div className="flex flex-col gap-2">
          {map(reminders?.items, (reminder) => (
            <Text key={reminder.id} variant="smBody">
              {formatReminder(reminder, t)}
            </Text>
          ))}
        </div>
      }
      className={className}
    >
      <IconContainer size="5" color="secondary">
        <BellRing />
      </IconContainer>
      {reminders?.items?.length > 1 && (
        <Text variant="smBodySecondary">{reminders?.items?.length}</Text>
      )}
    </DetailIconWrapper>
  );
};

export default RemindersIndicator;
